import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LoginComponent } from './pages/login/login/login.component';
import { ParticipantkeyboardComponent } from './pages/participant/participantkeyboard/participantkeyboard.component';
import { ParticipantscanComponent } from './pages/participant/participantscan/participantscan.component';
import { ParticipanteditComponent } from './pages/participant/participantedit/participantedit/participantedit.component';
import { MassStartComponent} from './pages/mass-start/mass-start/mass-start.component';
import { MassStartDoneComponent} from './pages/mass-start/mass-start-done/mass-start-done.component';
import {ScanComponent} from './pages/time/scan/scan.component';
import {TypeComponent} from './pages/time/type/type.component';

const routes: Routes = [
  { path: '', component: LoginComponent },
  { path: 'login', component: LoginComponent },
  { path: 'participantkeyboard', component: ParticipantkeyboardComponent }, 
  { path: 'participantscan', component: ParticipantscanComponent }, 
  { path: 'participantedit/:qrcode', component: ParticipanteditComponent }, 
  { path: 'mass-start/:event_name', component: MassStartComponent }, 
  { path: 'mass-start-done/:event_id/:event_name', component: MassStartDoneComponent }, 
  { path: 'type/:stage_type', component: TypeComponent },
  { path: 'scan/:stage_type', component: ScanComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }  